<script lang="ts">
  import { glyphOf } from "./icons.ts";
  import type { IconName } from "./icons.ts";

  let {
    name,
    size = 16,
    fill = false,
  }: { name: IconName; size?: number; fill?: boolean } = $props();

  const path = $derived(glyphOf(name, fill));
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 256 256"
  aria-hidden="true"
  width={size}
  height={size}
  class="shrink-0"
>
  {#if path !== undefined}
    <path fill="currentColor" d={path} />
  {/if}
</svg>
